/**
 * Created by Christof Sander on 02.02.2017.
 */

const utils = require('frontend-controller/lib/utils');

module.exports = {
	config: {
		active: true,
		environmentDependent: true,
		nextImageDelay: 0,
		focusAble: true,
		fullScreenOpacityDuration: .5,
		fullScreenDimensionChangeDuration: .3,
		startDelay: 10,
		stopOnMouseAction: true,
		hideThumbs: false,
		showArrows: false,
		showFullScreen: true,
		showFrame: true,
		fullScreenMargins: {
			height: 80,
			width: 200
		}
	},

	model: {
		startTimeout: undefined
	},

	events: {
		changeImageClick: {
			type: 'click',
			action: function(event){
				var self = event.data.component;
				var $target, $realTarget, $nextThumb;
				if(($target = $(event.target)).length > 0 && ($nextThumb = $target.closest('.thumb')).length > 0){
					// NOTE: next thumb navigation is central for all navigation cases
				}
				else if(($realTarget = $target.closest('.close, .background')).length > 0 && self.config.staticLookupName === 'fullScreenGallery'){
					event.stopImmediatePropagation();
					self.hide();
				}
				else if(($realTarget = $target.closest('.left, .right')).length > 0){
					if($realTarget.hasClass('left')){
						$nextThumb = event.data.component.model.$allThumbs.filter('.active').prev('.thumb');
						if($nextThumb.length <= 0) $nextThumb = event.data.component.model.$allThumbs.last();
					} else {
						$nextThumb = event.data.component.model.$allThumbs.filter('.active').next('.thumb');
						if($nextThumb.length <= 0) $nextThumb = event.data.component.model.$allThumbs.first();
					}
				}

				if($nextThumb.length > 0){
					clearTimeout(event.data.component.model.carouselTimeout);
					event.data.component.moveToImage($nextThumb);
					event.data.component.carouselTick();
				}
			}
		},

		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function(event){
				switch(utils.keyboard.getKeyCode(event)){
					case 'esc':
						var self = event.data.component;
						if(self.config.staticLookupName === 'fullScreenGallery'){
							event.stopImmediatePropagation();
							self.hide();
						}
						break;
				}
			}
		},

		fullScreenToggle: {
			type: 'click',
			selector: '.fullScreen',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				var self = event.data.component;

				if(self.config.staticLookupName !== 'fullScreenGallery' && self.activeEnvironment.style !== 'mobile'){
					var fullScreenGallery = getComponent('fullScreenGallery');
					fullScreenGallery.showClone(self);
				}
			}
		}
	},

	methods: {
		/**
		 * this function has to return true if the environment dependent refresh should be performed.
		 *
		 * @param   activeEnvironment               {} - active environment
		 * @param   newEnvironment                  {} - new environment
		 * @param   serverKnownEnvironment          {} - environment known by the server
		 * @param   initialExecution                boolean - is this the initial execution
		 * @param   externalDrivenCall              boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
		 * @param   environmentUpdateByParent       boolean - has a parent of mine decided to refresh and already updated by own activeEnvironment
		 * @returns boolean
		 */
		environmentRefreshNecessary: function(activeEnvironment, newEnvironment, serverKnownEnvironment, initialExecution, externalDrivenCall, environmentUpdateByParent){
			// check if loading options are in charge
			if(initialExecution && this.model._galleryImages.config.loadingOptions) return true;
			if(activeEnvironment.style != newEnvironment.style) return true;

			// check if multiple images are available
			var multipleImagesFound = false;
			utils.forEach(this.model.galleryImages, function(image){
				if(image.rendered && image.rendered.length > 1){
					multipleImagesFound = true;
					return false;
				}
			});
			if(!multipleImagesFound) return false;

			// check if environment has changed enough
			// breakPoint has been changed
			if(newEnvironment.breakPoint && activeEnvironment.breakPoint != newEnvironment.breakPoint && activeEnvironment.breakPointSize < newEnvironment.breakPointSize) return true;

			// fallback
			return false;
		},

		onGridUpdate: function(gridDimensions){
			this.model.maxWidth 	= (gridDimensions.x + gridDimensions.width - (this.config.fullScreenMargins.width * 2));
			this.model.maxHeight 	= (gridDimensions.y + gridDimensions.height - (this.config.fullScreenMargins.height * 2));
		},

		moveToImage: function($toImageThumb){
			var self = this;

			// activate current div
			this.model.$allThumbs.removeClass('active');
			$toImageThumb.addClass('active');

			// load source of active image
			var mediaID = $toImageThumb.data('mediaId');
			var mediaIndex;
			var image;
			if(this.config.staticLookupName === 'fullScreenGallery'){
				if(mediaID){
					for(mediaIndex in this.model.galleryImages){
						if(this.model.galleryImages[mediaIndex].mediaID === mediaID){
							image = this.model.galleryImages[mediaIndex];
							break;
						}
					}
					var usedImageDimensions = this.getFullScreenImageDimensions(image);

					var loadingImage = new Image();
					var onLoaded = function(){ self.onFullScreenImageLoaded(usedImageDimensions, this.src); };
					loadingImage.src = image.url;
					loadingImage.onload = onLoaded;
					loadingImage.onerror = onLoaded;
				}
			} else {
				this.model.$viewContainer.css('background-image', $toImageThumb.find('div').css('background-image'));
			}
		},

		onFullScreenImageLoaded: function(usedImageDimensions, imageUrl){
			TweenMax.to(
				this.model.$viewContainer.find(' > img').attr({ src: imageUrl }),
				this.config.fullScreenDimensionChangeDuration,
				{
					width: usedImageDimensions.width,
					height: usedImageDimensions.height
				}
			);
		},

		getFullScreenImageDimensions: function(image){
			var ratios = {
				x: image.width / this.model.maxWidth,
				y: image.height / this.model.maxHeight
			}
			var used = {
				width: image.width,
				height: image.height
			}

			if(ratios.x > ratios.y){
				if(image.width > this.model.maxWidth){
					used.width = this.model.maxWidth;
					used.height = Math.round(this.model.maxWidth * image.height / image.width);
				}
			} else {
				if(image.height > this.model.maxHeight){
					used.height = this.model.maxHeight;
					used.width = Math.round(this.model.maxHeight * image.width / image.height);
				}
			}

			return used;
		},

		carouselTick: function(){
			this.model.carouselTimeout = setTimeout(function(self){
				if(self.model.carouselStarted){
					var $nextThumb = self.$.find('.thumb.active').next('.thumb');
					if($nextThumb.length <= 0){
						$nextThumb = self.$.find('.thumb:not(.active)').first();
					}

					if($nextThumb.length > 0){
						self.moveToImage($nextThumb);
						self.carouselTick();
					}
				}
			}, this.config.nextImageDelay * 1000, this);
		},

		carouselStartTick: function(){
			this.model.carouselStarted = false;
			if(this.model.carouselStartTimeout){
				clearTimeout(this.model.carouselStartTimeout);
			}
			this.model.carouselStartTimeout = setTimeout(function(self){
				self.model.carouselStarted = true;
				if(self.model.carouselTimeout){
					clearTimeout(self.model.carouselTimeout);
				}
				self.carouselTick();
			}, this.config.startDelay * 1000, this);
		},

		showClone: function(sourceComponent){
			this.model.galleryImages 			= sourceComponent.model.galleryImages;
			this.model._galleryImages 			= sourceComponent.model._galleryImages;
			this.model.activeMediaIndex 		= sourceComponent.model.activeMediaIndex;
			utils.refReplace(this.config, sourceComponent.config, {
				active: true,
				showArrows: true
			});
			this.refresh();
			this.$.closest('section.fullScreen').addClass('isShown');
			this.$.focus();
		},

		hide: function(){
			this.model.galleryImages 			= {};
			this.model.preparedGalleryImages 	= {};
			this.config.active 					= false;
			this.refresh();
			this.$.closest('section.fullScreen').removeClass('isShown');
		}
	},

	hooks: {
		attach: function($element, options){
			// count images in image-list
			var imageCount = $element.find('.thumb').length;
			imageCount = imageCount>10 ? 10 : imageCount;

			// set class with number of images
			$element.addClass('size'+imageCount);

			// prepare often used jquery-elements
			this.model.$allThumbs 		= $element.find('.thumb');
			this.model.$viewContainer 	= $element.find('.image');

			if(this.config.hideThumbs){
				$element.addClass('hiddenThumbs');
			}

			// start carousel if necessary
			if(imageCount > 1 && this.config.nextImageDelay > 0){
				this.carouselStartTick();
			}

			if(this.config.staticLookupName === 'fullScreenGallery' && utils.collectionSize(this.model.preparedGalleryImages) > 0){
				var image = this.model.preparedGalleryImages[this.model.activeMediaIndex || 0];
				var usedImageDimensions = this.getFullScreenImageDimensions(image);
				this.model.$viewContainer.find(' > img').attr({
					width: usedImageDimensions.width,
					height: usedImageDimensions.height
				});
			}

		},

		onScroll: function($element, options){
			if(this.config.stopOnMouseAction && $element.find('.thumb').length > 1 && this.config.nextImageDelay > 0){
				this.carouselStartTick();
			}
		}
	}
};